import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header, Sidebar } from '../../components';
import { Route } from 'react-router';
import Organizations from '../Organizations';
import Dashboard from '../Dashboard';
import Library from '../Library';
import Users from '../Users';
import Projects from '../Projects';
import StudyCases from '../StudyCases';
import Glossary from '../Glossary';
import Profile from '../Profile';
import Dictionaries from '../Dictionaries';


import { set } from '../../actions/local-storage-actions';
import { getExternalDictionary } from '../../api';
import Survey from '../Survey/Survey';
import ResourceReport from '../Reports/ResourceReports';
import UserReport from '../Reports/UserReport';
import MainPage from '../MainPage';

class App extends Component {
  componentDidMount() {
    document.title = 'Dashboard | Masar App';
  }
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
    };
    this.sendToStore = this.sendToStore.bind(this);
    this.fetchDictionary = this.fetchDictionary.bind(this);
  }
  async componentWillMount() {
    let dictionary = await localStorage.getItem('dictionary');
    if (!dictionary) {
      this.setState({ fetching: true }, this.fetchDictionary);
    } else {
      this.sendToStore(JSON.parse(dictionary));
      this.fetchDictionary();
    }
  }
  sendToStore(data) {
    this.props.set('dictionary', data);
    this.setState({ fetching: false });
  }
  fetchDictionary() {
    getExternalDictionary(this.props.user.token)
      .then((dictionary) => {
        this.sendToStore(dictionary);
      })
      .catch((err) => {
        //TODO try to handle dictionary fail
      });
  }
  render() {
    if (this.state.fetching) {
      return (
        <div
          style={{
            backgroundColor: 'white',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img alt='Loading animation' src='https://www.twinspires.com/cdux/widgets/common/images/loading.gif' />
          <span style={{ marginTop: 8, fontWeight: 'bold', textAlign: 'center' }}>Syncing device</span>
          <span style={{ textAlign: 'center', color: '#CCC' }}>Sit tight, it will not be long....</span>
        </div>
      );
    }
    return (
      <div id='wrapper' className='forced'>
        <Header />
        <Sidebar />
        <div className='content-page'>
          <div className='content'>
            <div className='container-fluid'>
              <Route path={`${this.props.match.url}`} exact component={Dashboard} />
              <Route path={`${this.props.match.url}organizations`} component={Organizations} />
              <Route path={`${this.props.match.url}users`} component={Users} />
              <Route path={`${this.props.match.url}library`} component={Library} />
              <Route path={`${this.props.match.url}projects`} component={Projects} />
              <Route path={`${this.props.match.url}studycases`} component={StudyCases} />
              <Route path={`${this.props.match.url}glossary`} component={Glossary} />
              <Route path={`${this.props.match.url}dictionaries`} component={Dictionaries} />
              <Route path={`${this.props.match.url}profile`} component={Profile} />
              <Route path={`${this.props.match.url}reports`} component={Survey} />
              <Route path={`${this.props.match.url}resource-report`} component={ResourceReport} />
              <Route path={`${this.props.match.url}user-report`} component={UserReport} />
              <Route path={`${this.props.match.url}main-page`} component={MainPage} />

            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (s) => ({
  user: s.authReducer.user,
});

const mapDispatchToProps = (d) => ({
  set(key, value) {
    d(set(key, value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/routers/App/App.js